export const cleanCommaString = (input: string) => {
  return input
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item !== '')
    .join(',');
};

export const validateDuringInput = (input: string) => {
  return (
    input
      // 연속된 콤마(2개 이상)를 하나로 정리
      .replace(/,{2,}/g, ',')
      // 맨 앞의 콤마들 제거
      .replace(/^,+/g, '')
  );
};
